<template>
  <div class="register-verifier">
    <template v-if="isRegister">
      <div class="tips">您已绑定核销人员，无需重复绑定</div>
    </template>
    <template v-else>
      <template v-if="success">
        <div class="tips">绑定成功，请关闭此页面</div>
      </template>
      <template v-else>
        <div class="address-frame">
          <div class="address-edit-form-item border-bottom-style">
            <div class="form-title">绑定店铺</div>
            <div class="form-input">{{shop.name}}</div>
          </div>
          <div class="address-edit-form-item border-bottom-style">
            <div class="form-title">核销人员姓名</div>
            <input class="form-input" type="text" v-model="name" placeholder="请输入姓名"/>
          </div>
        </div>
        <div class="bank-card-save-btn" @click="register">绑定</div>
      </template>
    </template>
  </div>
</template>

<script>
  import {MessageBox, Toast} from 'mint-ui'
  import session from '../utils/Session'
  import userService from '../service/customer/UserService'
  import shopService from '../service/shop/ShopService'
  import verifierService from '../service/shop/VerifierService'
  import Header from "@/components/header/Header.vue";


  const param = [];
  param.push('appid=wxedd0b298e08a1998');
  param.push('redirect_uri='+encodeURIComponent('https://xyz.shuimujiaju.com/callback/index_v2.html?v=1'));
  param.push('response_type=code');
  param.push('scope=snsapi_userinfo');
  // param.push('state=' + '{\'redirectUrl\': \''+ window.location.href +'\'}');
  param.push('state=' + encodeURIComponent(window.location.href));
  const redirectUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?' + param.join('&');
  // const redirectUrl = 'https://open.weixin.qq.com/connect/qrconnect?' + param.join('&');

  export default {
  name: 'Auth',
  components: {
    'my-header': Header,
  },
  data: function () {
    return {
      shopId: '',
      shop: {},
      name: '',
      verifier: null,
      success: false,
      isWechatBrowser:this.$verfyBrowserType(),
    }
  },
  beforeMount () {
    if (this.$route.query) {
      this.shopId = this.$route.query.shopId || ''
      this.loadShop()
    }
    this.auth();
    window.document.title = '绑定核销人员'
  },
  computed: {
    isRegister() {
      return this.verifier
    }
  },
  methods: {
    loadShop() {
      if (this.shopId) {
        verifierService.getShop(this.shopId).then(result => {
          if (result.data) {
            this.shop = result.data || {}
          } else {
            MessageBox.confirm('参数错误')
          }
          console.log('shop==============', result)
        })
      }
    },
    async auth () {
      let code = this.$route.query.code;
      console.log('code=====', code)
      if(!code && !session.getOpenId()){
        window.location.href = redirectUrl;
      } else if(code){
        const result = await userService.getAccessToken(code);
        if (result.openId) {
          console.info(result.openId);
          const openId = result.openId || false;
          const unionId = result.unionId || false;
          session.unionId(unionId);
          session.nickname(result.nickname);
          session.avatar(result.headImgUrl);
          session.openId(openId);
          window.location.href = window.location.href.replace(/\&code=.*/, '')
          await this.loginByOpenid()
        } else {
          MessageBox.confirm('对不起，您的授权操作失败,请您重新授权!').then((action) => {
            window.location.href = redirectUrl;
          }).catch(e => {
            window.location.href = redirectUrl;
          });
        }
      } else if(session.getUnionId() || session.getOpenId()) {
        await this.loginByOpenid()
      }
    },
    async loginByOpenid() {
      const unionId = session.getUnionId() || ''
      const openId = session.getOpenId() || ''
      const result = await verifierService.getByUnionId(unionId, openId);
      if(result.code === '0' && result.data){
        this.verifier = result.data
      } else {
        this.name = session.getNickname() || ''
      }
    },
    register() {
      if (!this.name) {
        Toast('请填写姓名');
        return
      }
      if (!this.shop.id) {
        Toast('参数错误，请重新扫码');
        return
      }
      const message = `确定要将本微信绑定至[${this.shop.name}]店铺吗？`
      MessageBox.confirm(message).then((action) => {
        return verifierService.register({
          name: this.name,
          shopId: this.shop.id,
          unionId: session.getUnionId() || '',
          gzhOpenid: session.getOpenId() || '',
        })
      }).then(regRes => {
        console.log('regRes====', regRes)
        if (regRes.code === '0') {
          this.success = !!regRes.data
        } else {
          Toast(regRes.msg)
        }
      }).catch(e => {
      });
    }
  }
}
</script>
<style lang="scss">
@import '../assets/style/common.scss';
.register-verifier {
  height: 100vh;
  margin-top: -1rem;
  background-color: white;
  font-size: 0.32rem;
  .tips {
    width: 100%;
    text-align: center;
    padding-top: 2rem;
  }
  .address-frame {
    width: 6.9rem;
    margin: 0 auto;
  }
  .address-edit-form-item{
    width: 6.29rem;
    margin: 0 auto;
    padding-bottom: 0.2rem;
    .form-city{
      display: flex;
      justify-content: space-between;
    }
    .form-title{
      padding-top: 0.3rem;
      margin-bottom: 0.15rem;
      font-size: 0.28rem;
      color: #7f7d7c;
    }
    .city{
      box-sizing: border-box;
      margin-top: 0.2rem;
      width: 0.2rem;
      height: 0.2rem;
    }
    .form-input{
      width: 5rem;
      line-height: 0.3rem;
      font-size: 0.32rem;
      color: #191818;
    }
  }
  .operate-part{
    position: absolute;
    right: 0.3rem;
    padding-left: 0.3rem;
    height: 1.33rem;
    line-height: 1.2rem;
    display: flex;
    .delete-btn{
      width: 0.8rem;
      height: 0.4rem;
      margin-top: 0.4rem;
      margin-right: 0.3rem;
      font-size: 0.24rem;
      color: #ffffff;
      line-height: 0.4rem;
      text-align: center;
      border-radius: 20px;
      background-color: #d54a33;
    }
  }
  .icon-set-default{
    width: 0.37rem;
    height: 0.37rem;
    margin: 0.37rem 0.1rem 0.6rem 0;
    margin-top: 0.45rem;
  }
  .operation-text{
    margin-left: 0.1rem;
    flex-grow: 1;
  }
  .address-defaulted-color{
    color: #191818;
  }
  .bank-card-save-btn {
    position: fixed;
    bottom: 0.5rem;
    left:0;
    right:0;
    margin: 0 auto;
    width: 90%;
    height: 0.8rem;
    border-radius: 0.1rem;
    // margin: 6.5rem 0.3rem 0 0.3rem;
    text-align: center;
    background-color: rgb(0,71,142);
    font-size: 0.36rem;
    color: white;
    line-height: 0.85rem;
    letter-spacing: 0.05rem;
  }
}
</style>
